import { be, fi } from "date-fns/locale";

export const buildProductImgUrl = (product, h, w) => {
  if (product.imgUrl && product.imgUrl.startsWith("http")) {
    return product.imgUrl;
  } else {
    return (
      "http://vsestoritve-live.imgix" + //TODO
      product.imgUrl +
      "?max-h=" +
      h +
      "&max-w=" +
      w
    );
  }
};

export const roundToDecimal = (num, decimal) => {
  if (!num && num !== 0) return undefined;
  return parseFloat(num.toFixed(decimal || 0));
};

export const getHtmlNewlines = (text) => {
  if (!text) {
    return "";
  }
  return String(text).replace(/\n/g, "<br>");
};

export const displayName = (givenName, familyName) => {
  let dispayName = null;
  if (givenName) {
    dispayName = givenName;
  }

  if (givenName && familyName) {
    dispayName += " " + familyName.charAt(0) + ".";
  }
  return dispayName;
};

export const getReviewScoreDesc = (activeScore, selectedScore) => {
  let intSelectedScore = parseInt(selectedScore);
  let intActiveScore = parseInt(activeScore);
  switch (intActiveScore) {
    case 1:
      return "review.stars.s1";
    case 2:
      return "review.stars.s2";
    case 3:
      return "review.stars.s3";
    case 4:
      return "review.stars.s4";
    case 5:
      return "review.stars.s5";
    default:
      switch (intSelectedScore) {
        case 1:
          return "review.stars.s1";
        case 2:
          return "review.stars.s2";
        case 3:
          return "review.stars.s3";
        case 4:
          return "review.stars.s4";
        case 5:
          return "review.stars.s5";
        default:
          return "review.stars.s6";
      }
  }
};
export const getDetailedStars = (value, five) => {
  let decimal = value % 1;
  return five.map((i) => {
    if (decimal === 0) return i < value ? "polna.svg" : "prazna.svg";
    if (i < value - 1) return "polna.svg";
    if (i === parseInt(value)) {
      if (decimal <= 0.1) return "prazna.svg";
      if (decimal <= 0.3) return "cetrt.svg";
      if (decimal <= 0.6) return "pol.svg";
      if (decimal <= 0.8) return "tricetrt.svg";
      if (decimal <= 1) return "polna.svg";
    }
    return "prazna.svg";
  });
};

export const getInitialStars = (value, five) => {
  if (value) {
    return getDetailedStars(value, five);
  }
  return five.map((i) => "prazna.svg");
};

export const formatNumber = (number, decimals) => {
  if (number) {
    return Number(number + 0.00000001).toFixed(decimals); // adding 0.000001 to ensure correct rounding (3.65).toFixed(1)
  } else {
    return "0";
  }
};

export const calculateDifference = (current, before) => {
  if (before == 0) before = 1;
  if (current == 0) current = 1;

  return ((current - before) / before) * 100;
};
export const calculateDifference2 = (current, before) => {
  return (current - before);
};

export const calculateNpsDifference = (current, before) => {
  return current - before;
};